<template>
  <v-sheet color="var(--theme-color-four)">
    <Loading></Loading>
    <v-sheet
      min-width="var(--min-screen-width)"
      color="#F9FAFB"
      width="100vw"
      min-height="100vh"
      v-if="!isPreview"
    >
      <Header></Header>
      <div style="min-height: var(--header-height)"></div>
      <SideMenu v-if="$vuetify.breakpoint.lgAndUp"></SideMenu>

      <v-main>
        <div v-if="hasBreadcrumb()">
          <MenuBreadcrumb></MenuBreadcrumb>
          <div style="min-height: var(--breadcrumb-height)"></div>
        </div>
        <div class="custom-container">
          <!-- Pages -->
          <EachPageSplit></EachPageSplit>
        </div>
      </v-main>

      <Footer></Footer>
    </v-sheet>

    <v-sheet
      min-width="var(--min-screen-width)"
      color="#F9FAFB"
      width="100vw"
      min-height="100vh"
      v-else
    >
      <v-main>
        <div class="custom-container">
          <EachPageSplit></EachPageSplit>
        </div>
      </v-main>
    </v-sheet>
  </v-sheet>
</template>

<script>
import Header from "../components/Header";
import SideMenu from "@/components/SideMenu";
import MenuBreadcrumb from "@/components/MenuBreadcrumb";
import Footer from "@/components/Footer";
import { breadCrumbs, mainPage } from "../store/constants";
import Loading from "../components/Loading";

// ==========Routine Page to Deploy========== //
// ContactOR
import EachPageSplit from "./Calendar.vue";

export default {
  name: "Home",
  components: {
    Header,
    Footer,
    Loading,
    MenuBreadcrumb,
    SideMenu,
    EachPageSplit,
  },
  computed: {
    isPreview() {
      // check path is preview or not
      if (
        window.location.pathname.includes("TrainingPreview") ||
        window.location.pathname.includes("ArticlePreview") ||
        window.location.pathname.includes("NewsPreview") ||
        window.location.pathname.includes("ForgotPassword2")
      ) {
        return true;
      }
      return false;
    },
  },
  created() {
    // clear loading
    this.$store.commit("General/setLoading", false);
    console.log("route", this.$route);
  },
  methods: {
    hasBreadcrumb() {
      return !!breadCrumbs.find((x) => x.mainPage === mainPage);
    },
  },
};
</script>

<style scoped lang="scss">
.custom-container {
  padding: 32px 90px;
  background: #fff;
  position: relative;
  min-height: calc(
    100vh - var(--header-height) - var(--breadcrumb-height) -
      var(--footer-height)
  );
}

@media (max-width: 959px) {
  .custom-container {
    padding: 16px;
  }
}
</style>
